import React from 'react'
import styled from 'styled-components'

const HamburgerWrapper = styled.div`
  position: absolute;
  top: 12px;
`
interface IconProps {
  active?: boolean
}

export const HamburgerIcon = styled.span<IconProps>`
  background: ${({ theme }) => theme.iconColor};
  display: block;
  height: 1px;
  position: relative;
  ${(props) => props.active && 'background: none'};
  transition: background 0.2s ease-out;
  width: 14px;

  &:before,
  &:after {
    background: ${({ theme }) => theme.iconColor};
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    transition: all 0.2s ease-out;
    width: 100%;
  }

  &:before {
    top: 6px;
    ${(props) => props.active && 'transform: rotate(-45deg); top: 0px;'};
  }
  &:after {
    top: -6px;
    ${(props) => props.active && 'transform: rotate(45deg); top: 0px;'};
  }
`
type Props = {
  isOpen: boolean
}
export const Hamburger = (props: Props): JSX.Element => {
  return (
    <HamburgerWrapper>
      <HamburgerIcon active={props.isOpen} />
    </HamburgerWrapper>
  )
}
